


interface OrderPlannedIconProps {
	className?: string,
}


const OrderPlannedIcon = (props: OrderPlannedIconProps) => {
	const { className } = props;

	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="custom-order-planned-icon"
			className={`svg-inline--fa fa-custom-order-planned-icon${className ? ` ${className}` : ''}`}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 537 512">
			<path fill="currentColor" d="m-4.87,235.57l0,264.8c0,8.33 8.33,14.04 15.47,10.24l127.52,-66.38c3.57,-1.9 5.95,-5.95 5.95,-10.24l0,-233.64c0,-1.9 -0.47,-4.05 -1.43,-5.7l-11.66,-21.41c-2.85,-5.23 -8.8,-7.14 -13.8,-4.76l-115.87,56.63c-3.81,1.9 -6.19,5.95 -6.19,10.24l0,0.24l0.01,-0.01z"/>
			<path fill="currentColor" d="m175,276.73l0,156.32c0,4.76 2.85,9.04 7.14,10.71l162.74,62.58c7.14,2.62 14.51,-2.85 14.51,-10.71l0,-217.94c0,-10.24 -11.66,-15.23 -18.56,-8.09l-64.24,85.89c-4.05,4.52 -10.95,4.52 -15.23,0l-68.05,-86.84c-6.9,-6.9 -18.32,-1.9 -18.32,8.09l0.01,0z"/>
			<path fill="currentColor" d="m384.85,223.67l0,269.57c0,8.57 8.33,14.04 15.7,10.24l124.91,-65.67c3.57,-1.9 5.95,-5.95 5.95,-10.24l0,-256.72c0,-8.09 -7.61,-13.56 -14.76,-10.47l-124.91,53.05c-4.05,1.67 -6.66,5.95 -6.66,10.47l-0.24,-0.24l0.01,0.01z"/>
			<path fill="currentColor" d="m268.26,2.64c-61.15,0 -110.64,52.34 -110.64,116.81c0,31.17 9.51,61.38 27.12,86.36l71.62,102.07c5.23,7.61 16.18,7.61 21.41,0l76.13,-108.26c16.41,-23.31 25.22,-51.39 25.22,-80.41c0,-64.47 -49.49,-116.81 -110.64,-116.81l-0.24,0.24l0.01,0zm-1.19,155.59c-16.18,0 -29.5,-14.04 -29.5,-31.17s13.09,-31.17 29.5,-31.17s29.5,14.04 29.5,31.17s-13.09,31.17 -29.5,31.17z"/>
		</svg>
	);
};

export default OrderPlannedIcon;